import { useSyncExternalStore } from "react";

function list(query: string): MediaQueryList | null {
  try {
    return window.matchMedia(query);
  } catch {
    // No matchMedia (jsdom, very old browsers): the phone layout, which is the primary one.
    return null;
  }
}

/** Whether a media query matches now, following it as the window changes. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const media = list(query);
      media?.addEventListener("change", onChange);
      return () => media?.removeEventListener("change", onChange);
    },
    () => list(query)?.matches ?? false,
    () => false,
  );
}
